import { render, staticRenderFns } from "./pointer.vue?vue&type=template&id=5e3f19ba&scoped=true"
import script from "./pointer.vue?vue&type=script&lang=js"
export * from "./pointer.vue?vue&type=script&lang=js"
import style0 from "./pointer.vue?vue&type=style&index=0&id=5e3f19ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3f19ba",
  null
  
)

export default component.exports